(function($) {

  'use strict';

  function Header() {

    var self = this,
      $el = null,
      $ctn = $('.header__bottom'),
      $btn = $('.header__btn-mobile'),
      $menuItem = $('.menu-item-has-children'),

      options = {
        example: null,
      };

    /**
     * Generic resize
     */
    /*function onResize() {
      // Example
      if (window.bp.getLastValue() !== window.bp.getValue()) {
        if (window.bp.getValue() === 'xl') {
          console.log('header, xl');
        }

        if (window.bp.getValue() === 'lg') {
          console.log('header, lg');
        }

        if (window.bp.getValue() === 'md') {
          console.log('header, md');
        }

        if (window.bp.getValue() === 'sm') {
          console.log('header, sm');
        }

        if (window.bp.getValue() === 'xs') {
          console.log('header, xs');
        }
      }
  }*/


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      // extends options
      for (var i in opts) { options[i] = opts[i]; }

      console.log('header');

      // Caching
      $el = options.$el;
      $btn.on('click', function() {
          if($ctn.hasClass('js-isOpen')) {
              $ctn.removeClass('js-isOpen');
          } else {
              $ctn.addClass('js-isOpen');
          }
      });

      $menuItem.on('click', function() {
        if($(this).hasClass('js-openSubmenu')){
            $(this).removeClass('js-openSubmenu');
        } else {
            $menuItem.removeClass('js-openSubmenu');
            $(this).addClass('js-openSubmenu');
        }
      });


      var isFixed = false;
      var headerBottom = $('.js-header-bottom'),
          headerBottomPosTop = headerBottom.position().top;

      $(window).scroll(function(){
        var scrollTop = $(window).scrollTop();

        if(scrollTop >= headerBottomPosTop && !isFixed){
          headerBottom.addClass('is-fixed');
          isFixed = true;
        }
        if(scrollTop < headerBottomPosTop && isFixed){
          headerBottom.removeClass('is-fixed');
          isFixed = false;
        }
      });

      // *************
      //window.cache.$window.on('resize', Utils.debounce(onResize, 3000));
      // Initial call on load
      //onResize();
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.Header = Header;

}(jQuery));
